import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import CartDrawer from "./components/CartDrawer";
import AIAssistant from "./components/AIAssistant";
import HomePage from "./pages/HomePage";
import ShippingQuoterPage from "./pages/ShippingQuoterPage";
import TrackingPage from "./pages/TrackingPage";
import DigitalArchivePage from "./pages/DigitalArchivePage";
import CatalogPage from "./pages/CatalogPage";
import StorePage from "./pages/StorePage";
import OrderHistoryPage from "./pages/OrderHistoryPage";
import ServicesPage from "./pages/ServicesPage";
import FranchisePage from "./pages/FranchisePage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import MyArchivePage from "./pages/MyArchivePage";
import AdminPage from "./pages/AdminPage";
import PrepaidGuidesPage from "./pages/PrepaidGuidesPage";
import MyGuidesPage from "./pages/MyGuidesPage";
import CheckoutResultPage from "./pages/CheckoutResultPage";
import MultichannelPage from "./pages/MultichannelPage";
import AnalyticsDashboardPage from "./pages/AnalyticsDashboardPage";
import ProfilePage from "./pages/ProfilePage";
import PasswordResetPage from "./pages/PasswordResetPage";
import InventoryPage from "./pages/InventoryPage";
import APIDocs from "./pages/APIDocs";
import FulfillmentDashboard from "./pages/FulfillmentDashboard";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Navbar />
            <CartDrawer />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/cotizar" element={<ShippingQuoterPage />} />
              <Route path="/rastreo" element={<TrackingPage />} />
              <Route path="/archivo-digital" element={<DigitalArchivePage />} />
              <Route path="/catalogo" element={<CatalogPage />} />
              <Route path="/tienda" element={<StorePage />} />
              <Route path="/mis-pedidos" element={<OrderHistoryPage />} />
              <Route path="/servicios" element={<ServicesPage />} />
              <Route path="/franquicias" element={<FranchisePage />} />
              <Route path="/contacto" element={<ContactPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/mi-archivo" element={<MyArchivePage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/guias-prepago" element={<PrepaidGuidesPage />} />
              <Route path="/mis-guias" element={<MyGuidesPage />} />
              <Route path="/checkout/result" element={<CheckoutResultPage />} />
              <Route path="/multicanal" element={<MultichannelPage />} />
              <Route path="/analitica" element={<AnalyticsDashboardPage />} />
              <Route path="/perfil" element={<ProfilePage />} />
              <Route path="/recuperar-contrasena" element={<PasswordResetPage />} />
              <Route path="/inventario" element={<InventoryPage />} />
              <Route path="/fulfillment" element={<FulfillmentDashboard />} />
              <Route path="/documentacion-api" element={<APIDocs />} />
            </Routes>
            <Footer />
            <AIAssistant />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
